const images = require.context('../images', true);
const imagePath = (name) => images(name, true);

/* our styles */
import "stylesheets/rsct16_public.scss";

// relounge dependencies
// import jQuery from "src/rsct16_public/vendor/jquery/jquery-2.1.4.js";
const jQuery = require("src/rsct16_public/vendor/jquery/jquery-2.1.4.js");
// Assign to global scope
window.jQuery = jQuery;
window.$ = jQuery;

require("src/rsct16_public/vendor/carousel/GAniFw.js");
require("src/rsct16_public/vendor/jwplayer/jwplayer.js");
require("src/rsct16_public/vendor/fancybox/jquery.fancybox.js");
require("src/rsct16_public/vendor/slick/slick.js");
require("src/rsct16_public/vendor/velocity/velocity.js");
require("src/rsct16_public/vendor/velocity/velocity.ui.js");
require("src/rsct16_public/vendor/matchMedia/matchMedia.js");
require("src/rsct16_public/vendor/picturefill/picturefill.js");
require("src/rsct16_public/vendor/jquery-rwdImageMaps/jquery.rwdImageMaps.js");

import VideoPlayer from "src/rsct16_public/modules/video-player.js";
import Tabs from "src/rsct16_public/modules/tabs.js";
import Menu from "src/rsct16_public/modules/menu.js";
import Accordion from "src/rsct16_public/modules/accordion.js";
import ChoiceLoader from "src/rsct16_public/modules/choice-loader.js";
import GridSlide from "src/rsct16_public/modules/grid-slide.js";
import Form from "src/rsct16_public/modules/form.js";
import LikeBox from "src/rsct16_public/modules/like-box.js";
import Stage from "src/rsct16_public/modules/stage.js";
import BuyBox from "src/rsct16_public/modules/buy-box.js";
import NetPrice from "src/rsct16_public/modules/net-price.js";
import ProductGallery from "src/rsct16_public/modules/product-gallery.js";
import NewsletterTeaser from "src/rsct16_public/modules/newsletter-teaser.js";
import PerspectivePreview from "src/rsct16_public/modules/perspective-preview.js";
import ScrollUpButton from "src/rsct16_public/modules/scroll-up-button.js";
// relounge dependencies END

require("src/rsct16_public/main.js");
require("src/rsct16_public/popups.js");
require("src/rsct16_public/cookie-consent-setup.js");
require("src/rsct16_public/external-links.js");
require("src/shared/city_select.js");
require("src/shared/checkout.js");
require("src/shared/payone_cc.js");
require("src/shared/payment.js");
